var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkerAllowanceDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.731,
    height: 94.147,
    viewBox: "0 0 71.731 94.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-3-fill",
    d: "M75.731,95.147H4V86.181A22.416,22.416,0,0,1,26.416,63.765h26.9A22.416,22.416,0,0,1,75.731,86.181ZM39.866,54.8a26.9,26.9,0,1,1,26.9-26.9A26.9,26.9,0,0,1,39.866,54.8Z",
    transform: "translate(-4 -1)",
    fill: "#efefef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkerAllowanceDefault);
export default __webpack_public_path__ + "static/media/WorkerAllowanceDefault.7c477d5080571410ead80491761cd643.svg";
export { ForwardRef as ReactComponent };